/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/**
 * Onboarding API client (Tier 1 / 2 / 3 progressive flow).
 * Applies to all professional categories: medici, infermieri, OSS.
 */

export const getOnboardingStatus = () =>
  api.get('/onboarding/status').then((r) => r.data);

export const saveTier1 = (payload) =>
  api.put('/onboarding/tier1', payload).then((r) => r.data);

export const sendEmailOTP = (email) =>
  api.post('/onboarding/tier1/email-otp/send', email ? { email } : {}).then((r) => r.data);

export const verifyEmailOTP = (code) =>
  api.post('/onboarding/tier1/email-otp/verify', { code }).then((r) => r.data);

export const saveTier2 = (payload) =>
  api.put('/onboarding/tier2', payload).then((r) => r.data);

export const uploadRegistryEvidence = (image_data_url) =>
  api.post('/onboarding/tier2/registry-evidence', { image_data_url }).then((r) => r.data);

export const uploadCV = (pdf_data_url) =>
  api.post('/onboarding/tier2/cv', { pdf_data_url }).then((r) => r.data);

export const saveTier3 = (payload) =>
  api.put('/onboarding/tier3', payload).then((r) => r.data);

// Admin
export const listPendingVerifications = () =>
  api.get('/admin/onboarding/pending-verifications').then((r) => r.data);

export const reviewRegistry = (userId, action, reason) =>
  api.post(`/admin/onboarding/verify-registry/${userId}`, { action, reason }).then((r) => r.data);

/**
 * Convert a File to a base64 data URL suitable for uploads.
 */
export const fileToDataURL = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });

/**
 * Registry types by professional category.
 */
export const REGISTRY_TYPES_BY_CATEGORY = {
  medici: [{ value: 'fnomceo', label: 'Albo FNOMCeO (Medici)' }],
  infermieri: [{ value: 'opi', label: 'OPI — Ordine Professioni Infermieristiche' }],
  oss: [{ value: 'oss_qualification', label: 'Attestato di qualifica OSS (regionale)' }],
};

/**
 * Client-side CF format check.
 */
export const isValidCF = (cf) => /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i.test((cf || '').trim());
export const isValidPhone = (p) => /^\+?\d[\d\s\-]{6,20}$/.test((p || '').trim());
export const isValidPIVA = (v) => /^\d{11}$/.test((v || '').trim());
